/* Lite YouTube embed — the player (an iframe on youtube-nocookie.com) exists only after the shopper presses play.
   Delegated + guarded so the script can be included by several sections safely.
   2026-10-16 (PDP redesign): two ways to play — inline (the poster is replaced, as before) and lightbox (a card in the
   "See It in Action" grid opens one shared <dialog>; closing it removes the iframe, so playback stops and focus returns
   to the card). Also the "View all N videos" control of that grid. No autoplay ever happens without the click. */
(function () {
  if (window.__ameYtLiteBound) return;
  window.__ameYtLiteBound = true;

  var ALLOW = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
  var src = function (id) { return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1'; };

  var box = null, opener = null;
  function lightbox() {
    if (box) return box;
    box = document.createElement('dialog');
    box.className = 'ame-vid-lightbox';
    box.setAttribute('aria-label', 'Video player');
    box.innerHTML = '<div class="ame-vid-lightbox__bar"><p class="ame-vid-lightbox__title" data-vid-lb-title></p>' +
      '<button type="button" class="ame-vid-lightbox__close" data-vid-lb-close aria-label="Close video">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button></div>' +
      '<div class="ame-vid-lightbox__frame" data-vid-lb-frame></div>';
    document.body.appendChild(box);
    box.addEventListener('click', function (e) { if (e.target === box) box.close(); });
    box.querySelector('[data-vid-lb-close]').addEventListener('click', function () { box.close(); });
    box.addEventListener('close', function () {
      var f = box.querySelector('[data-vid-lb-frame]'); if (f) f.innerHTML = '';   // stops playback
      if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
      opener = null;
    });
    return box;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-yt-lite-play]');
    if (!btn) return;
    var wrap = btn.closest('[data-yt-lite]');
    if (!wrap) return;
    var id = wrap.getAttribute('data-video-id');
    if (!id) return;
    var title = btn.getAttribute('aria-label') || 'Video player';
    var iframe = document.createElement('iframe');
    iframe.src = src(id);
    iframe.title = title.replace(/^Play video:\s*/, '');
    iframe.allow = ALLOW;
    iframe.allowFullscreen = true;
    iframe.className = 'ame-yt-lite__iframe';
    if (wrap.getAttribute('data-yt-lite-mode') === 'lightbox' && typeof HTMLDialogElement === 'function') {
      var d = lightbox();
      opener = btn;
      d.querySelector('[data-vid-lb-title]').textContent = iframe.title;
      var frame = d.querySelector('[data-vid-lb-frame]'); frame.innerHTML = ''; frame.appendChild(iframe);
      d.showModal();
      // focus stays on the Close button, NOT inside the player: a cross-origin iframe swallows Escape, so a focused player
      // would leave the dialog with no keyboard way out (measured 2026-10-16 on the DEV theme)
      d.querySelector('[data-vid-lb-close]').focus();
      return;
    }
    btn.replaceWith(iframe);   // inline (the featured slot, legacy single embeds, and lightbox mode without <dialog> support)
    iframe.focus();
  });

  /* "View all N videos" (desktop): the grid hides cards beyond the second until pressed; phones show every card in one
     swipeable row, so the control only matters where the CSS hides something. */
  var more = document.querySelector('[data-vid-more]');
  var grid = document.querySelector('[data-vid-grid]');
  if (more && grid && grid.querySelector('[data-vid-extra]')) {
    more.hidden = false;
    more.addEventListener('click', function () {
      var open = !grid.classList.contains('is-expanded');
      grid.classList.toggle('is-expanded', open);
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      var total = grid.querySelectorAll('[data-yt-lite]').length + 1;
      more.textContent = open ? 'Show fewer videos' : 'View all ' + total + ' videos';
      if (open) { var first = grid.querySelector('[data-vid-extra] [data-yt-lite-play]'); if (first) first.focus({ preventScroll: true }); }
    });
  }
})();
